<div class="progress-container" *ngIf="steps != null && steps != undefined">
  <div class="header-container">
    <div
      *ngFor="let item of steps; let i = index"
      class="progress-step-item"
      [style.width]="itemWidth"
    >
      <div
        [class.progress-step-item-disable]="i + 1 > currentStep"
        [class.progress-step-item-highlight]="i + 1 == currentStep"
        [class.progress-step-item-enabled]="i + 1 < currentStep"
      >
        <ng-container *ngIf="!titleTemplate">
          <div style="padding-left: 5px; padding-right: 5px">
            <div style="width: 100%; padding-left: 5px; padding-right: 5px">
              <div class="progress-step-item-title">
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template
          *ngIf="titleTemplate"
          let-item
          [ngTemplateOutlet]="titleTemplate"
          [ngTemplateOutletContext]="{
            item: item
          }"
        ></ng-template>
      </div>
    </div>
  </div>
  <div class="progress-line-container">
    <div
      *ngFor="let item of steps; let i = index"
      class="progress-step-item"
      [style.width]="itemWidth"
    >
      <div
        [class.progress-step-item-disable]="i + 1 > currentStep"
        [class.progress-step-item-highlight]="i + 1 == currentStep"
        [class.progress-step-item-enabled]="i + 1 < currentStep"
      >
        <ng-container *ngIf="!lineTemplate">
          <div class="left-progress" *ngIf="i > 0"></div>
          <div class="right-progress" *ngIf="i < steps.length - 1"></div>
          <span class="progress-step-item-number"></span>
        </ng-container>
        <ng-template
          *ngIf="lineTemplate"
          let-item
          [ngTemplateOutlet]="lineTemplate"
          [ngTemplateOutletContext]="{
            item: item,
            i: i,
            length: steps.length
          }"
        ></ng-template>
      </div>
    </div>
  </div>
  <div class="date-container">
    <div
      *ngFor="let item of steps; let i = index"
      class="progress-step-item"
      [style.width]="itemWidth"
    >
      <div
        [class.progress-step-item-disable]="i + 1 > currentStep"
        [class.progress-step-item-highlight]="i + 1 == currentStep"
        [class.progress-step-item-enabled]="i + 1 < currentStep"
      >
        <ng-container *ngIf="!dateTemplate">
          <span class="progress-step-item-date" *ngIf="item.date">{{
            item.date | datex : 'ddd DD MMM HH:mm'
          }}</span>
        </ng-container>
        <ng-template
          *ngIf="dateTemplate"
          let-item
          [ngTemplateOutlet]="dateTemplate"
          [ngTemplateOutletContext]="{
            item: item
          }"
        ></ng-template>
      </div>
    </div>
  </div>
</div>
